// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__30edW","insightsList":"newBusinessInsightsMenu_insightsList__6w7q8","active":"newBusinessInsightsMenu_active__2SvN7"};